import React from 'react';
import type { CompetitorRow, HealthSegment } from '../types';

const SEG_COLOR: Record<HealthSegment, string> = {
  unmanaged: 'text-rose-700',
  amateur:   'text-amber-700',
  agency:    'text-brand-700',
  optimized: 'text-leaf-700',
};

const CompetitorTable: React.FC<{ rows: CompetitorRow[] }> = ({ rows }) => (
  <div className="py-4 border-b border-slate-200">
    <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
      <h3 className="text-[13px] font-semibold text-slate-900">商圏内 競合ベンチマーク</h3>
      <span className="text-[11px] text-slate-500">同エリアの上位3店舗との指標比較</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-[12px] border-collapse">
        <thead>
          <tr className="border-b border-slate-200 text-slate-600">
            <th className="text-left py-2 font-semibold">店舗</th>
            <th className="text-right py-2 font-semibold">マップ順位</th>
            <th className="text-right py-2 font-semibold">駅から</th>
            <th className="text-right py-2 font-semibold">評価</th>
            <th className="text-right py-2 font-semibold">口コミ</th>
            <th className="text-right py-2 font-semibold">写真</th>
            <th className="text-right py-2 font-semibold">健全度</th>
            <th className="text-left py-2 font-semibold">セグメント</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c, i) => (
            <tr key={i} className={`border-b border-slate-100 ${c.is_self ? 'bg-leaf-50/40 font-semibold' : ''}`}>
              <td className="py-2 text-slate-900">
                {c.is_self && <span className="text-[10px] mr-1 px-1 py-0 bg-brand-500 text-white rounded">自店</span>}
                {c.title}
              </td>
              <td className="py-2 text-right tabular-nums">{c.rank} 位</td>
              <td className="py-2 text-right tabular-nums text-slate-600">
                {c.distance_from_station_m !== null && c.distance_from_station_m !== undefined
                  ? `${c.distance_from_station_m} m`
                  : '-'}
              </td>
              <td className="py-2 text-right tabular-nums">{c.rating !== null ? c.rating.toFixed(1) : '-'}</td>
              <td className="py-2 text-right tabular-nums">{c.review_count ?? 0}</td>
              <td className="py-2 text-right tabular-nums">{c.photo_count}</td>
              <td className="py-2 text-right tabular-nums">{c.health_score}</td>
              <td className={`py-2 text-[11px] ${SEG_COLOR[c.segment]}`}>{c.segment_label}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default CompetitorTable;
